import React from 'react';
import intl from 'react-intl-universal';
import { Button } from 'antd';
import { MULTI_TABS_TYPES } from '@/components/MultiTabsBar/contant';
import store from '@/store';
import { SHARE_BUTTON } from '@/components/viewer/ui/constants/user.more.constants';
// import { fileController } from '@/components/viewer/Controllers';
import { COLLECT_NPS_SURVEY } from '@/constants/app.constant';
import { isDTRuntime } from '@/modules/3rd-party-integration/utils/env';
import { START_SHARE_DOC } from 'Components/viewer/ui/constants/collaboration.constants';

export default class ShareDocButton extends React.Component<{ disabled: boolean }> {
    render() {
        const { isOnPremiseDeployMode } = store.appStore;
        if (isOnPremiseDeployMode) return null;

        const { multiTabsTabPaneActiveType } = store.viewer;
        if (multiTabsTabPaneActiveType !== MULTI_TABS_TYPES.DOC) {
            return null;
        }
        let text = intl.get('HeaderContainer.ShareBtn');
        if (isDTRuntime) {
            text = '钉钉共享';
        }
        return <Button className="share-btn" onClick={showShareDlg} disabled={this.props.disabled}>{text}</Button>
    }
}

async function showShareDlg() {
    store.appStore.updateCurrentClickBtnName(START_SHARE_DOC)
    if (store.viewer.pdfui.customs?.isAccountExpired && store.viewer.pdfui.customs?.isAccountExpired(true)) {
        return;
    }
    store.userStore.doSendGAEventByUser({ eventKey: SHARE_BUTTON, label: 'upper_right_area' } as any);

    if (!window.__online__) {
        store.appStore.doNotifyErrors('offline');
        return;
    }

    if (!store.appStore.checkAppSignIn()) {
        return;
    }

    // const checkAnnotFormPermission = await fileController.checkAnnotFormPermission();// 此方法判断有误
    const docRender = store.viewer.pdfui.pdfViewer.getPDFDocRender();
    const checkAnnotFormPermission = docRender.getUserPermission().checkAnnotForm();
    if (checkAnnotFormPermission === 0) {
        store.appStore.setGlobalMessage({ type: 'error', content: intl.get('collaboration.Dlg.noPermission') });
        return;
    }

    const doc = await window.pdfui.getCurrentPDFDoc();
    if (doc && doc.isPortfolio()) {
        store.appStore.setGlobalMessage({ type: 'error', content: intl.get('collaboration.Error.portfolioNotSupport') });
        return;
    }

    store.appStore.emitEvent(COLLECT_NPS_SURVEY);
    if (store.viewer.hasOpenFile) {
        if (store.appStore.isIncludeFoxitStorage) {
            if (store.storageAppStore.isDisableStorage) {
                window.pdfui.alert({ message: intl.get('FoxitStorage.DisableStorage.SharedAlert'), level: 'prompt' });
            } else {
                store.storageAppStore.syncAutoSaveOnDocModified().finally(() => {
                    store.collaborationStore.changeShareDialogState(true);
                });
            }
        } else {
            store.collaborationStore.changeShareDialogState(true);
        }
    }
}
